import React from "react";
import { GiWallet } from "react-icons/gi";
import { MdAccountBalanceWallet } from "react-icons/md";
import { Link } from "react-router-dom";

function DepositWithdraw() {
  return (
    <>
      <div className="flex justify-between item-center h-9 w-full ">
        <Link
          to={"/deposit"}
          className="depositas w-[50%] p-1 flex justify-center item-center bg-gradient-to-b from-[#17C964] to-[#20402D] text-white text-center font-bold"

        >
          <span>Deposit</span>
          <span className="ml-2">
            {/* <img src="/Images/bank.webp" alt="" className="w-6 mr-1" /> */}
            <MdAccountBalanceWallet
              size={25}
              color="white"
              style={{ marginRight: 0, marginLeft: 0 }}
            />
          </span>
        </Link>
        <Link
          to={"/withdraw"}
          className="w-[50%] p-1 flex justify-center item-center bg-gradient-to-b from-[#CF3232] to-[#331414] text-white text-center font-bold"
        >
          <span>Withdraw</span>
          <span className="ml-2">
            <GiWallet size={25} color="white" style={{ marginRight: 0 }} />
          </span>
        </Link>
      </div>
    </>
  );
}

export default DepositWithdraw;
